import { BaseStore } from '@lumapps/redux/types';

/**
 * Retrieves the instance object
 * @param  {Object} state The redux state.
 * @return {Object} Instance state
 */
export const instanceSelector = (state: BaseStore) => state.instance || {};

/**
 * Retrieves the id of the current instance
 * @param  {Object} state The redux state.
 * @return {string} Instance id
 */
export const instanceIdSelector = (state: BaseStore) => {
    const instance = instanceSelector(state);

    return instance.uid || instance.id;
};
